import { CSSProperties } from 'react';

export const containerStyle: CSSProperties = {
  width: '100%',
  height: 'calc(100vh - 120px)',
  marginTop: '100px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  zIndex: 2,
  overflow: 'hidden'
};
